import {
  Component,
  Input,
  OnChanges,
  OnInit,
  QueryList,
  SimpleChanges,
  ViewChildren,
} from "@angular/core";
import { NewsEntry } from "@core/services/newsEntry";
import { Sponsor } from "@shared/models/sponsor";
import { TypeService } from "@core/services/type.service";
import { PageType } from "../../../../../../page-type";
import { INewsPost } from "@api/models/news/news";
import { NewsListItemComponent } from "@shared/modules/shared-news-list/components/news-list-item/news-list-item.component";

@Component({
  selector: "app-news-list",
  templateUrl: "./news-list.component.html",
  styleUrls: ["./news-list.component.scss"],
})
export class NewsListComponent implements OnInit, OnChanges {
  @Input() newsEntries: NewsEntry[] | INewsPost[];
  @Input() sponsors: Sponsor[];
  @Input() showRegisterAsReporterCard: boolean = false;
  @Input() hasReporter = false;
  @ViewChildren(NewsListItemComponent)
  newsCards: QueryList<NewsListItemComponent>;
  mainSponsors: Sponsor[] = [];
  premiumSponsors: Sponsor[] = [];
  normalSponsors: Sponsor[] = [];
  otherSponsors: Sponsor[] = [];
  alreadyMentionedSponsors: Sponsor[] = [];
  randomSponsors: Sponsor[] = [];
  scrollOffsetForAds: number = 0;
  scrollOffsetForAdsMobile: number = 0;
  adIdForNewsList: string;

  constructor() {}

  ngOnInit(): void {
    if (TypeService.pageType === PageType.Home) {
      this.scrollOffsetForAds = 160;
      this.scrollOffsetForAdsMobile = 152;
      this.adIdForNewsList =
        "/6771346/sfa_fan.at/web.fan.at/homepage/beside_left1";
    }
    if (TypeService.pageType === PageType.Team) {
      this.scrollOffsetForAds = 317;
      this.scrollOffsetForAdsMobile = 127;
      this.adIdForNewsList =
        "/6771346/sfa_fan.at/web.fan.at/teams/column_left1";
    }
    if (TypeService.pageType === PageType.League) {
      this.scrollOffsetForAds = 272;
      this.scrollOffsetForAdsMobile = 218;
      this.adIdForNewsList = "/6771346/sfa_fan.at/web.fan.at/liga/column_left1";
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      this.newsEntries != null &&
      this.sponsors != null &&
      this.sponsors.length !== 0
    ) {
      this.setSponsors();
    }
  }

  handleReload(e) {
    this.newsCards.forEach((card) => {
      if (card.newsPost.creator.creatorid === e) {
        card.userIsFollowingTeam = true;
      }
    });
  }

  setSponsors() {
    for (let i = 0; i < this.sponsors.length; i++) {
      const sponsor = this.sponsors[i];
      if (sponsor.type === "main_sponsor") {
        this.mainSponsors.push(sponsor);
      } else if (sponsor.type === "premium_sponsor") {
        this.premiumSponsors.push(sponsor);
      } else if (sponsor.type === "normal_sponsor") {
        this.normalSponsors.push(sponsor);
      } else {
        this.otherSponsors.push(sponsor);
      }
    }
    this.selectRandomSponsors();
  }

  selectRandomSponsors() {
    this.alreadyMentionedSponsors = [];
    const filterFun = (sponsor) => {
      return (
        this.alreadyMentionedSponsors.findIndex(
          (sp) => sp.id === sponsor.id
        ) === -1
      );
    };

    while (true) {
      let sponsorsToPickFrom: Sponsor[] = [];
      const mainSponsors = this.mainSponsors.filter(filterFun);
      if (mainSponsors.length !== 0) {
        sponsorsToPickFrom = mainSponsors;
      }
      const pick = Math.floor(Math.random() * sponsorsToPickFrom.length);
      const randomSponsor = sponsorsToPickFrom[pick];

      this.alreadyMentionedSponsors.push(randomSponsor);
      this.randomSponsors.push(randomSponsor);

      if (this.randomSponsors.length >= this.newsEntries.length / 5) {
        break;
      }
    }
  }
}
